import { Link } from 'react-router-dom';
import { ArrowRight, LogIn, Search } from 'lucide-react';

import { Button } from '@/components/ui/button';

export default function WelcomePage() {
  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-lg text-center space-y-8" data-testid="welcome-page">
        <div className="flex items-center justify-center gap-3">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className="text-foreground">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="text-3xl font-bold">BitSwan</span>
        </div>

        <p className="text-muted-foreground">
          Automate the work your business does by hand, with an automation
          advisor to set it up with you.
        </p>

        <div className="flex flex-col gap-3">
          <Button asChild size="lg" data-testid="welcome-signup">
            <Link to="/signup">
              Get started free
              <ArrowRight className="h-4 w-4 ml-2" />
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" data-testid="welcome-catalogue">
            <Link to="/public/advisors">
              <Search className="h-4 w-4 mr-2" />
              Browse automation advisors
            </Link>
          </Button>
          <Button asChild variant="ghost" data-testid="welcome-signin">
            <Link to="/login">
              <LogIn className="h-4 w-4 mr-2" />
              Sign in
            </Link>
          </Button>
        </div>

        <p className="text-xs text-muted-foreground">
          30 days free with one Bailey server. If your company already uses
          BitSwan, ask an admin there to invite you rather than signing up again.
        </p>
      </div>
    </div>
  );
}
